'use client';

import dynamic from 'next/dynamic';

// Utilisation de dynamic import dans un composant client (ce qui est autorisé)
const OfflineMode = dynamic(
  () => import('@/components/OfflineMode'),
  { ssr: false }
);

export default function OfflineModeClientWrapper() {
  return <OfflineMode />;
}
